// Organization Data Table Configuration - matching admin-web structure
import React from 'react';
import { Text, View } from 'react-native';
import { IColumnConfig } from '@/types/admin/dataTable';
import { IOrganizationRowData } from '@/types/admin/organizations';
import { formatTaskDate } from '@/utils/admin/date';
import { ADMIN_COLORS } from '@/constants/admin';

export const organizationTableColumns: IColumnConfig<IOrganizationRowData>[] = [
  {
    key: 'name',
    label: 'NAME',
    sortable: true,
    sortType: 'string',
    filterable: true,
    filterType: 'text',
    width: 200,
    visible: true,
    renderCell: (value: string, row: IOrganizationRowData) => (
      <View>
        <Text style={{ fontWeight: '700', fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY }}>{value}</Text>
      </View>
    ),
  },
  {
    key: 'domain',
    label: 'DOMAIN',
    sortable: true,
    sortType: 'string',
    filterable: true,
    filterType: 'text',
    width: 200,
    visible: true,
    renderCell: (value: string, row: IOrganizationRowData) => (
      <View>
        <Text style={{ fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY }}>{value}</Text>
      </View>
    ),
  },
  {
    key: 'createdAt',
    label: 'CREATED AT',
    sortable: true,
    sortType: 'date',
    filterable: true,
    filterType: 'date',
    width: 150,
    visible: true,
    renderCell: (value: string, row: IOrganizationRowData) => (
      <View>
        <Text style={{ fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY  }}>
          {value ? formatTaskDate(value) : 'N/A'}
        </Text>
      </View>
    ),
  },
];

